<script lang="ts">
  let welcomeHidden = false;
  setTimeout(function () {
    welcomeHidden = true;
  }, 2500);
</script>

<div class="welcome" class:hidden={welcomeHidden}>
  <div class="intro-box">
    <img src="/img/the-stocks-v3.svg" alt="" class="animated fadeInUp" />
    <div class="divs">
      <div class="animated fadeInUp" />
      <div class="animated fadeInUp" />
      <div class="animated fadeInUp" />
    </div>
  </div>
</div>

<style lang="scss">
  @import '../styles/_mixins';
  .hidden {
    opacity: 0;
    pointer-events: none;
  }

  .welcome {
    position: fixed;
    left: 0;
    z-index: 10000;
    background: var(--color-blue-gray--800);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    transition: all 0.6s;

    .intro-box {
      text-align: center;
    }
    img {
      width: 500px;
      max-width: 90%;
      margin: 0 auto;
      animation-delay: 0.4s;
      display: block;
      clear: both;
      position: relative;
      top: -100px;
    }
    .divs {
      width: 100%;
      height: 20px;
      position: absolute;
      left: 0px;
      margin-top: -50px;
      div {
        height: 10px;
        width: 300px;
        background: #6880ff;
        display: inline-block;
        margin-top: 70px;
        margin-left: 10px;
        margin-right: 10px;
        animation-delay: 200ms;
        box-shadow: 0px 3px 80px #6880ff;
        &:nth-child(2) {
          background: #35b19e;
          animation-delay: 500ms;
          box-shadow: 0px 3px 80px #35b19e;
        }
        &:nth-child(3) {
          background: white;
          animation-delay: 700ms;
          box-shadow: 0px 3px 80px white;
        }
      }
    }
  }
</style>
